// NosVehiculesContent.js
import React, { useState, useEffect } from "react";
import AnnonceCard from "./AnnonceCard";
import "./NosVehiculesContent.css";
import { getApiBaseUrl } from "./config/api";
import { Helmet } from "react-helmet-async";

// URL de l'API backend (VPS avec IP fixe)
const API_URL = getApiBaseUrl();

function NosVehiculesContent({ navigateToVehicle, standalone = false }) {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [maxKilometres] = useState(200000);
  const [maxPrix] = useState(100000);
  const [minAnnee] = useState(1900);

  // Véhicules filtrés en fonction des filtres
  const filteredVehicles = vehicles.filter((vehicle) => {
    // dateCirculation est maintenant une string ISO depuis l'API (ex: "2020-05-15")
    const date = vehicle.dateCirculation ? new Date(vehicle.dateCirculation) : null;
    const year = date ? date.getFullYear() : 0;
    
    return (
      Number(vehicle.kilometrage) <= maxKilometres &&
      Number(vehicle.prix) <= maxPrix &&
      year >= minAnnee
    );
  });

  const handleVehicleClick = (vehicle) => {
    const reference = vehicle?.reference || vehicle?.id;

    if (reference && typeof navigateToVehicle === "function") {
      navigateToVehicle(reference);
    }
  };

  useEffect(() => {
    let isMounted = true;
    async function getData() {
      try {
        setLoading(true);
        setError(null);
        
        // Appel à l'API backend VPS (IP fixe, synchronisée toutes les 30 min)
        const response = await fetch(`${API_URL}/api/vehicles`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        });
        
        if (!response.ok) {
          throw new Error(`Erreur API: ${response.status}`);
        }
        
        const vehiclesData = await response.json();
        const vehiclesByNewestArrival = [...vehiclesData].sort((a, b) => {
          const aCreatedAt = new Date(a.createdAt || 0).getTime();
          const bCreatedAt = new Date(b.createdAt || 0).getTime();
          return bCreatedAt - aCreatedAt;
        });
        
        // Les véhicules sont déjà au bon format depuis l'API
        // Ils contiennent déjà les URLs des images hébergées sur le VPS
        if (isMounted) {
          setVehicles(vehiclesByNewestArrival);
          setLoading(false);
          console.log(`✅ ${vehiclesData.length} véhicules chargés depuis l'API`);
        }
      } catch (error) {
        console.error("❌ Erreur lors du chargement des véhicules:", error);
        if (isMounted) {
          setError(error.message);
          setLoading(false);
        }
      }
    }
    
    getData();
    
    return () => {
      isMounted = false;
    };
  }, []);

  // Show a loading message while data is being fetched
  if (loading) {
    return (
      <div style={{ padding: '50px', textAlign: 'center' }}>
        <h2>⏳ Chargement des véhicules...</h2>
        <p>Récupération des données depuis notre serveur sécurisé</p>
      </div>
    );
  }

  // Show error message if data fetch failed
  if (error) {
    return (
      <div style={{ padding: '50px', textAlign: 'center' }}>
        <h2>❌ Erreur de chargement</h2>
        <p>{error}</p>
        <button onClick={() => window.location.reload()} style={{ marginTop: '20px', padding: '10px 20px' }}>
          🔄 Réessayer
        </button>
      </div>
    );
  }

  return (
    <div>
      {standalone && (
        <Helmet>
          <title>Nos véhicules d'occasion en stock | FLIP MY CAR</title>
          <meta name="description" content="Découvrez notre sélection de véhicules d'occasion de qualité à Chambourcy (78). Garantie premium, livraison possible, service complet." />
          <link rel="canonical" href="https://flipmycar.fr/nos-vehicules" />
          <meta property="og:title" content="Nos véhicules d'occasion en stock | FLIP MY CAR" />
          <meta property="og:description" content="Découvrez notre sélection de véhicules d'occasion de qualité à Chambourcy (78)." />
          <meta property="og:url" content="https://flipmycar.fr/nos-vehicules" />
          <meta property="og:type" content="website" />
          <meta property="og:image" content="https://flipmycar.fr/logo2.png" />
          <meta name="twitter:card" content="summary" />
          <meta name="twitter:title" content="Nos véhicules en stock | FLIP MY CAR" />
          <meta name="twitter:description" content="Découvrez notre sélection de véhicules d'occasion de qualité." />
        </Helmet>
      )}
      <div className="ColTitleVDispo">
        {standalone ? (
          <h1 className="titleVDispo titleStock">NOS VÉHICULES<br /><span style={{color: '#50bf8f'}}>EN STOCK</span></h1>
        ) : (
          <h2 className="titleVDispo titleStock">NOS VÉHICULES<br /><span style={{color: '#50bf8f'}}>EN STOCK</span></h2>
        )}
        {/*<img
          src={process.env.PUBLIC_URL + "/megane4.png"}
          className="Megane4Title"
          alt='Megane4'
        /> */}
      </div>
      {/* <div className="filters">
        <label>
          Kilométrage maximum:
          <select
            value={maxKilometres}
            onChange={(e) => setMaxKilometres(Number(e.target.value))}
            className="select"
          >
            <option value={10000}>10 000 km</option>
            <option value={25000}>25 000 km</option>
            <option value={35000}>35 000 km</option>
            <option value={50000}>50 000 km</option>
            <option value={75000}>75 000 km</option>
            <option value={100000}>100 000 km</option>
            {/* Ajoutez d'autres options au besoin */}
          {/* </select>
        </label>

        <label>
          Prix maximum:
          <select
            value={maxPrix}
            onChange={(e) => setMaxPrix(Number(e.target.value))}
            className="select"
          >
            <option value={20000}>20 000 €</option>
            <option value={30000}>25 000 €</option>
            <option value={30000}>30 000 €</option>
            <option value={40000}>40 000 €</option>
            <option value={50000}>50 000 €</option>
            <option value={75000}>75 000 €</option>
            <option value={100000}>100 000 €</option>
            {/* Ajoutez d'autres options au besoin */}
          {/* </select>
        </label>

        <label>
          Année minimum:
          <select
            value={minAnnee}
            onChange={(e) => setMinAnnee(Number(e.target.value))}
            className="select"
          >
            <option value={2014}>2014</option>
            <option value={2015}>2015</option>
            <option value={2016}>2016</option>
            <option value={2017}>2017</option>
            <option value={2018}>2018</option>
            <option value={2019}>2019</option>
            <option value={2020}>2020</option>
            <option value={2021}>2021</option>
            <option value={2022}>2022</option>

            {/* Ajoutez d'autres options au besoin */}
          {/* </select>
        </label>
      </div> */}
      <div>
        {filteredVehicles.length === 0 ? (
          <h1 className="NoVehicleFound">
            Aucun véhicule trouvé avec les filtres actuels.
          </h1>
        ) : (
          <div className="vehicle-list-container">
            <div className="vehicle-list">
              {filteredVehicles.map((vehicle, index) => (
                <AnnonceCard
                  key={index}
                  vehicle={vehicle}
                  onVehicleClick={() => handleVehicleClick(vehicle)}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default NosVehiculesContent;
